/* eslint-disable no-console */
import Cookies from 'js-cookie'
// import { auth, googleProvider, StoreDB, functions } from '@/services/firebase'
import { auth } from '@/services/firebase'

export const state = () => ({
  uid: null,
  user: null,
  isAdmin: false,
})

export const getters = {
  uid(state) {
    if (state.user && state.user.uid) {
      return state.user.uid
    } else {
      return null
    }
  },
  user(state) {
    return state.user
  },
  userEmail(state) {
    if (state.user) {
      return state.user.email
    } else {
      return ''
    }
  },
  isAuthenticated(state) {
    return !!state.user && !!state.user.uid
  },
  isAdmin(state) {
    return state.isAdmin
  },
}

export const actions = {
  async login({ commit, dispatch }, { data, emailMarketing = false }) {
    const token = await auth.currentUser.getIdToken(true)
    const idTokenResult = await auth.currentUser.getIdTokenResult()
    let userInfo = {}
    let isAdmin = false
    console.log('data', data)
    const { user, additionalUserInfo } = data
    const { providerId, isNewUser } = additionalUserInfo
    // Check claims if admin
    if (
      typeof idTokenResult.claims.email !== 'undefined' &&
      typeof idTokenResult.claims.email_verified !== 'undefined' &&
      idTokenResult.claims.email_verified &&
      idTokenResult.claims.email.endsWith('@pedalsure.com') &&
      idTokenResult.claims.email === 'gancho.danailov@pedalsure.com'
    ) {
      isAdmin = true
    }

    console.log('providerId', providerId)

    switch (providerId) {
      case 'password':
        console.log('password')
        userInfo = {
          email: user.email,
          uid: user.uid,
          displayName: user.displayName || '',
        }
        break
      case 'google.com':
        console.log('google.com')
        userInfo = {
          email: user.email,
          uid: user.uid,
          displayName: user.displayName || '',
        }
        break
      case 'facebook.com':
        console.log('facebook.com')
        userInfo = {
          email: user.email,
          uid: user.uid,
          displayName: user.displayName || '',
        }
        break
      case 'apple.com':
        console.log('apple.com')
        // Apple may relay/hide the email; fall back to the firebase user email.
        userInfo = {
          email: user.email,
          uid: user.uid,
          displayName: user.displayName || '',
        }
        break
      default:
        console.log('default')
        userInfo = {
          email: user.email || 'anonymous@pedalsure.com',
          uid: user.uid,
          displayName: user.displayName || '',
        }
    }

    if (isNewUser) {
      console.log('new customer', { userInfo, emailMarketing })
      await dispatch('customerCreated', { userInfo, emailMarketing })
    }

    Cookies.set('access_token', token, { sameSite: 'lax' })
    commit('SET_USER', userInfo)
    commit('quote/SET_QUOTE_USER_DETAILS_EMAIL', userInfo.email, { root: true })
    if (isAdmin) {
      commit('SET_USER_ADMIN', isAdmin)
    }
  },

  async logout({ commit, dispatch }) {
    console.log('[STORE ACTIONS] - logout')
    await auth.signOut()
    Cookies.remove('access_token')
    commit('SET_USER', {})
  },

  setUser({ commit }, user) {
    commit('SET_USER', user)
  },

  async customerCreated({ commit, dispatch }, { userInfo, emailMarketing }) {
    if (userInfo.email) {
      await this.$axios.$post(
        '/api/mailchimp/v1/add-customer-to-audience-list',
        { userInfo, emailMarketing }
      )
    } else {
      console.log('login as guest')
    }
  },

  async generateCustomToken({ commit }, uid) {
    const token = await this.$axios.$post(
      '/api/auth/v1/generate-custom-token',
      { uid }
    )
    return token
  },
}

export const mutations = {
  SET_USER(state, user) {
    console.log('[STORE MUTATIONS] - SET_USER:', user)
    state.user = user
  },
  SET_USER_ADMIN(state, isAdmin) {
    state.isAdmin = isAdmin
  },
}
